import ABOUT from "./about";

export default ABOUT;
